
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 12 12","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.973 3.389l-.902-1.623a.617.617 0 00-.098-.739.62.62 0 00-.736-.097L8.61.027a.212.212 0 00-.253.035L6.814 1.606a.212.212 0 00-.055.206l.547 2.003-1.242 1.241a.746.746 0 00-.59.205l-.536.535 1.266 1.265.535-.535A.74.74 0 006.956 6c0-.024-.004-.047-.006-.07l1.235-1.236 2.003.546a.212.212 0 00.206-.055l1.544-1.543a.213.213 0 00.035-.253zM6.74 5.474l-.213-.213c-.01-.011-.024-.019-.036-.03L7.693 4.03l2.694-2.694c.09-.078.207-.084.285-.007.09.09.06.21 0 .278l-2.7 2.7L6.769 5.51c-.01-.012-.019-.025-.03-.036zM4.66 8.604L3.395 7.34l.471-.47 1.265 1.264-.47.471zM1.982 8.753a.74.74 0 00-.04 1.004l-1.88 1.88a.212.212 0 10.3.3l1.881-1.88a.735.735 0 001.004-.039l.384-.384L2.365 8.37l-.383.384zM5.432 7.833L4.167 6.567l.47-.47 1.266 1.265-.47.47zM3.931 9.333L2.666 8.068l.429-.428L4.36 8.905l-.429.428z"}})])
          )
        }
      }
    